<template>
  <div class="row">
    <div class="col-4 col-md-2 text-muted text-right prevent-select">{{name}}</div>
    <div class="col-8 col-md-10">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String
  }
}
</script>
